// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NVgt","controls":"styles_controls__18uio","charLimit":"styles_charLimit__3A71V","input":"styles_input__3TqO4","send":"styles_send__3nZK-"};